import React from "react";

/**
 * Ловит ошибки рендера панели ассистента.
 *
 * Без этого падение рендера размонтирует поддерево, и снаружи это выглядит как
 * «клик по кнопке ничего не делает» — именно так выглядел баг, из-за которого
 * boundary и появился.
 */
export default class AssistantErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error("[assistant] ошибка рендера панели:", error, info);
  }

  render() {
    if (!this.state.failed) return this.props.children;

    return (
      <div style={styles.box}>
        <div>Ассистент не смог отрисоваться. Обновите страницу.</div>
        {this.props.onClose && (
          <button type="button" style={styles.btn} onClick={this.props.onClose}>
            Закрыть
          </button>
        )}
      </div>
    );
  }
}

const styles = {
  box: {
    padding: 16,
    fontSize: 15,
    color: "var(--c-text-sub)",
    display: "flex",
    flexDirection: "column",
    gap: 10,
    alignItems: "flex-start",
  },
  btn: {
    fontSize: 14,
    padding: "6px 10px",
    borderRadius: 99,
    border: "1px solid var(--c-border)",
    background: "transparent",
    color: "var(--c-text)",
    cursor: "pointer",
  },
};
